const ARCHIVED_VALUES = new Set([true, 1, '1', 'true', 'archived']);

export function isArchivedEvent(event) {
  return ARCHIVED_VALUES.has(event?.is_archived ?? event?.archived ?? false);
}

export function getActiveEvents(events = []) {
  return events.filter((event) => !isArchivedEvent(event));
}

export function getArchivedEvents(events = []) {
  return events.filter(isArchivedEvent);
}
